import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.195 32.938a7.17 7.17 0 0 1-7.157-6.78 26 26 0 0 1 0-2.822 7.17 7.17 0 0 1 7.157-6.781h3.563l1.579-1.777a62 62 0 0 1 7.574-7.2l1.127-.903a3.072 3.072 0 0 1 4.98 2.115q.604 6.57.604 15.957 0 9.383-.603 15.951a3.072 3.072 0 0 1-4.983 2.114l-1.18-.948a62.6 62.6 0 0 1-7.669-7.31l-1.43-1.616zm3.044-14.335h-3.044a5.12 5.12 0 0 0-5.112 4.843 24 24 0 0 0 0 2.6 5.12 5.12 0 0 0 5.112 4.844h3.044zm2.048-.686v13.66l1.434 1.62a60.5 60.5 0 0 0 7.418 7.07l1.18.948a1.023 1.023 0 0 0 1.66-.704q.596-6.468.596-15.764-.001-9.3-.596-15.769a1.023 1.023 0 0 0-1.66-.705l-1.128.904a60 60 0 0 0-7.323 6.96zm24.999 5.81 4.396 4.396c.965.965-.483 2.413-1.448 1.448l-4.396-4.396-4.396 4.396c-.965.965-2.413-.483-1.448-1.448l4.396-4.396-4.396-4.396c-.965-.965.483-2.413 1.448-1.448l4.396 4.396 4.396-4.396c.965-.965 2.413.483 1.448 1.448z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.195 32.938a7.17 7.17 0 0 1-7.157-6.78 26 26 0 0 1 0-2.822 7.17 7.17 0 0 1 7.157-6.781h3.563l1.579-1.777a62 62 0 0 1 7.574-7.2l1.127-.903a3.072 3.072 0 0 1 4.98 2.115q.604 6.57.604 15.957 0 9.383-.603 15.951a3.072 3.072 0 0 1-4.983 2.114l-1.18-.948a62.6 62.6 0 0 1-7.669-7.31l-1.43-1.616zm3.044-14.335h-3.044a5.12 5.12 0 0 0-5.112 4.843 24 24 0 0 0 0 2.6 5.12 5.12 0 0 0 5.112 4.844h3.044zm2.048-.686v13.66l1.434 1.62a60.5 60.5 0 0 0 7.418 7.07l1.18.948a1.023 1.023 0 0 0 1.66-.704q.596-6.468.596-15.764-.001-9.3-.596-15.769a1.023 1.023 0 0 0-1.66-.705l-1.128.904a60 60 0 0 0-7.323 6.96z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m40.286 23.727 4.396 4.396c.965.965-.483 2.413-1.448 1.448l-4.396-4.396-4.396 4.396c-.965.965-2.413-.483-1.448-1.448l4.396-4.396-4.396-4.396c-.965-.965.483-2.413 1.448-1.448l4.396 4.396 4.396-4.396c.965-.965 2.413.483 1.448 1.448z"
    }
  )
);
var SvgSoundOffOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundOffOutlined_default = SvgSoundOffOutlined;

export { SoundOffOutlined_default as default };
